<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb"/>
    <div class="flexBox">
      <text-title mainTitle="包月停车费(非固定车位)" subheading="" />
      <div>
        <a @click="save">保存</a>
        <a @click="cel">取消</a>
      </div>
    </div>

    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">单价：</span>
        </div>
        <el-input v-model="unitPrice" size="small" style="width: 280px" >
          <template slot="append">元</template>
        </el-input>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">缴费周期：</span>
        </div>
        <el-select v-model="paymentCycle" placeholder="请选择" size="mini" style="width: 280px" >
          <el-option
            v-for="item in paymentCycleList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">备注：</span>
        </div>
        <el-input type="textarea" :row="3" v-model="memo" size="small" style="width: 280px" />
      </div>

    </form>
  </div>
</template>

<script>
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'
  import {pattern} from '../../../utils/regular'
  import {api} from '../../api/ParkingService'
  import TextTitle from '../../../components/Text/TextTitle'
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      Breadcrumb,
      TextTitle,
    },
    name: 'parking-month-config-un-modify',
    data () {
      return {
        config: {
          breadcrumb: [{
            value: '智慧停车',
            name: 'park-yard'
          }, {
            value: '缴费配置'
          }],
        },
        maxlength: 32,
        paymentCycleList: [
          {
            label: '月缴',
            value: '1'
          }, {
            label: '季缴',
            value: '2'
          }, {
            label: '半年缴',
            value: '3'
          }, {
            label: '年缴',
            value: '4'
          },
        ],
        code: '',
        unitPrice: '',
        paymentCycle: '',
        memo: '',
      }
    },
    created () {
      this.code = this.$route.params.code
      this.unitPrice = this.$route.params.unitPrice
      this.paymentCycle = this.$route.params.paymentCycle
      this.memo = this.$route.params.memo
    },
    methods: {
      cel () {
        this.$router.push({
          name: 'parking-month-config-un-center'
        })
      },
      save () {
        let obj = {
          code: this.code,
          unitPrice: this.unitPrice,
          paymentCycle: this.paymentCycle,
          memo: this.memo,
          configType: 2,
          parkingLotType: 2
        }
        if (!this.code) {
          this.$axios.post(api.addParkingBasicConfig, obj)
            .then(res => {
              nSuccess('添加成功')
              this.cel()
            })
            .catch(errorHandler('添加失败'))
        } else {
          this.$axios.post(api.updateParkingPaymentConfig, obj)
            .then(res => {
              nSuccess('修改成功')
              this.cel()
            })
            .catch(errorHandler('修改失败'))
        }
      }
    },
    watch: {}
  }
</script>

<style scoped>
  .main_right {
    text-align: left;
  }
  .flexBox {
    display: flex;
    justify-content: space-between;
  }

  .flexBox a{
    line-height: 58px;
    margin-right: 40px;
    cursor: pointer;
    color: #00a0e6;
  }
  .flexBox a:hover{
    color: #06b3ff;
  }
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 20px 0;
  }
  .form-line>span {
    font-size: 12px;
    color: #97a8be;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
    vertical-align: top;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>

<style lang="less">
  .main_right {
    .faceConfigTip {
      display: inline-block;
      min-width: 80px;
      text-align: right;
    }
    .faceConfigInput {
      display: inline-block;
      width: 313px;
      height: 28px;
      margin-left: 10px;
      .el-input__inner {
        height: 28px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingConfig/ParkingMonthConfigUnModify.vue